import styled from 'styled-components';

interface IContainer {
  disabled?: boolean;
  active?: boolean;
}

export const Container = styled.div<IContainer>`
  display: flex;
  width: 100%;
  padding: 12px 16px;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  background-color: ${({ active }) => (active ? '#f5f7fb' : 'transparent')};
  padding: 16px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  & + & {
    margin-top: 16px;
  }
`;

export const Texts = styled.div`
  flex: 1;
`;

export const Title = styled.div<IContainer>`
  font-size: 14px;
  font-weight: 500;
  color: ${({ active }) => (active ? '#1371fe' : '#8f95b2')};
`;

export const ComingSoon = styled.span`
  font-size: 16px;
  font-weight: 300;
  color: #838a91;
`;

export const Description = styled.div<IContainer>`
  font-size: 10px;
  font-weight: 400;
  color: ${({ active }) => (active ? '#1371fe' : '#8f95b2')};
`;
